module.exports = __webpack_public_path__ + "static/media/fred.e8e423a7.jpg";